import { RouteObject } from "react-router-dom";
import mastersRouteList from "./routeList";
import clinicMastersRoute from "./ClinicMasters";
import templateMasterRoutes from "./TemplateMaster";
import generalMasterRoute from "./GeneralMasters";
import insuranceMasterRoutes from "./insuranceMasters";
import PrivateRoute from "../Authentication/component/PrivateRoute";
import Loader from "../utilis/component/SkeletonLoading/Loader";
import { lazy } from "react";

const CreateFormPage = lazy(() => import("./GoogleForms/CreateForm"));

const mastersRoutes: RouteObject[] = [
  {
    path: mastersRouteList.clinicMaster,
    children:clinicMastersRoute
  },
  {
    path: mastersRouteList.generalMaster,
    children:generalMasterRoute
  },
  {
    path: mastersRouteList.templateMaster,
    children: templateMasterRoutes
  },
  {
    path: mastersRouteList.insuranceMaster,
    children: insuranceMasterRoutes
  },
  {
    path: mastersRouteList.googleForms,
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Loader>
              <CreateFormPage />
            </Loader>
          </PrivateRoute>
        ),
      },
      {
        path: mastersRouteList.googleFormsCreate,
        element: (
          <PrivateRoute>
            <Loader>
              <CreateFormPage />
            </Loader>
          </PrivateRoute>
        ),
      },
    ],
  },
];

export default mastersRoutes;
